import { LoadingOverlay } from '@mantine/core';

import { AuthenticationModuleClientType } from '../../../../types';

export const RedirectPage: AuthenticationModuleClientType['RedirectPage'] = () => {
  return <LoadingOverlay visible />;
};
